import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons';

function SuccessModal({ 
  show = false, 
  onHide = () => {}, 
  modalTitle, // Keep for backward compatibility
  title, // New prop name being used
  message = '', 
  variant = 'success', // 'success' or 'error'
  ...rest 
}) {
  const isSuccess = variant === 'success';
  
  const config = {
    success: {
      icon: CheckCircleFill,
      iconColor: '#28a745',
      background: '#e6ffed',
      border: '#b6f0c7',
      textClass: 'text-success',
      defaultTitle: 'Success'
    },
    error: {
      icon: XCircleFill,
      iconColor: '#dc3545',
      background: '#ffe6e6',
      border: '#ffb3b3',
      textClass: 'text-danger',
      defaultTitle: 'Error'
    }
  };

  const currentConfig = config[variant] || config.success;
  const Icon = currentConfig.icon;
  // Support both 'title' and 'modalTitle' props, prefer 'title' if both provided
  const displayTitle = title || modalTitle || currentConfig.defaultTitle;

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="delete-modal-sm" {...rest}>
      <Modal.Body className="text-center p-4">
        <div className="d-flex flex-column align-items-center justify-content-center mb-2">
          <span
            style={{
              background: currentConfig.background,
              borderRadius: '50%',
              padding: 16,
              display: 'inline-flex',
              marginBottom: 12,
              border: `2px solid ${currentConfig.border}`,
            }}
          >
            <Icon size={38} color={currentConfig.iconColor} />
          </span>
          <h5 className={`fw-bold ${currentConfig.textClass} mb-2`} style={{ fontSize: '1.1rem' }}>
            {displayTitle}
          </h5>
        </div>
        <div className="mb-3">
          <span className="fw-semibold">{message}</span>
        </div>
        <div className="d-flex gap-2 justify-content-center">
          <Button variant="primary" size="sm" onClick={onHide}>
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SuccessModal;
